export class Filter {
  offset: number = 0;
  limit: number = 10;
  order: string = null;
  orderBy: string = null;
}